import { render, staticRenderFns } from "./TelDetailTable.vue?vue&type=template&id=1d5ad2a8"
import script from "./TelDetailTable.vue?vue&type=script&lang=js"
export * from "./TelDetailTable.vue?vue&type=script&lang=js"
import style0 from "./TelDetailTable.vue?vue&type=style&index=0&id=1d5ad2a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports